import { render, staticRenderFns } from "./BirchEquipment.html?vue&type=template&id=4f37e63a&scoped=true&external"
import script from "./BirchEquipment.js?vue&type=script&lang=js&external"
export * from "./BirchEquipment.js?vue&type=script&lang=js&external"
import style0 from "./BirchEquipment.scss?vue&type=style&index=0&id=4f37e63a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f37e63a",
  null
  
)

export default component.exports